import React, {useEffect, useState} from "react";


import {CardCarousel} from "../components/CardCarousel";
import {ConfirmModal} from "../../terraforming/utils/Modal";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";


export const PlayLeader = (props) => {

    const [state, setState] = useState({
        showPopup: false,
        init: false,
        show: false,
        card: false,
        action: false
    });

    const actions = props.state.actions[props.userId];
    const cards = [];
    for (let action of actions) {
        if (cards.map(c => c.building.idname).indexOf(action.card.building.idname) === -1) {
            cards.push(action.card);
        }
    }


    useEffect(() => {
        if (!state.action || !state.card) {
            handleChangeActiveCard(0);
        }
    }, [state]);


    function handleChangeActiveCard(index) {
        setState(state => ({
            ...state,
            action: actions.filter(a => a.card.building.idname === cards[index].building.idname)[0],
            card: cards[index],
            init: true
        }));
    }

    if (!state.card) {
        return <div></div>;
    }
    let currentActionName = "Êtes-vous sûr de vouloir jouer " + state.card.building.name + " ?";
    const playLeaderActions = actions.filter(action => action.card.building.idname === state.card.building.idname);
    return (
        <div style={{
            marginTop: "0", marginLeft: "5%", marginRight: "5%", display: "block",
            width: "90%", color: "#DDD"
        }}>
            <ConfirmModal
                open={state.show}
                action={state.action}
                text={currentActionName}
                socket={props.socket}
                onDismiss={() => setState(state => ({...state, show: false}))}
            />
            <h2>
                Jouer un leader
            </h2>
            <div style={{height: "40vh"}}>
                <CardCarousel
                    activeIndex={cards.map(c => c.building.idname).indexOf(state.card.building.idname)}
                    cards={cards.map(c => c.building)}
                    onSelect={handleChangeActiveCard} key={"carouselCards"}/>
            </div>
            <div style={{width: "100%", textAlign: "center", margin: "2vh 0"}}>
                {
                    playLeaderActions.map((a, i) => <Box
                        className={"board-game-build-action"}
                        sx={{width: {xs: "120%", md: "100%"}, marginLeft: {xs: "-13%", md: "-3%"}}}
                        key={i}>
                        <div className="board-game-build-action-container">
                            {a.ok ? 'Vous pouvez jouer ce leader' : "Vous n'avez pas les moyens de jouer ce leader"}
                        </div>
                        <Button variant="contained" disabled={!a.ok}
                                onClick={() => setState(state => ({...state, action: a, show: true}))}>
                            Jouer
                        </Button>
                    </Box>)
                }

            </div>
            <Card className="panel panel-primary" style={{marginTop: 10, marginBottom: 20}}>
                <CardContent className="panel-heading">
                    <div className={"card-title"}>
                        Description : {state.card.building.name}
                    </div>
                    <div className="panel-body">
                        <p>{state.card.building.description}</p>
                    </div>
                </CardContent>
            </Card>
            <div style={{height: "25vh"}}>

            </div>
        </div>
    )

};

export default PlayLeader;
